import { formatDateWithTemplate } from "../../../../../../../utils/format/date";
import { IdleDetailingItem } from "../../../../../../../types/service/dashboard/IWorksDashboardService";
import  { sum, isNumber } from "lodash";
import { dataLabelsFormatter, formatTime } from "../../../../../../../utils/format/time";
import { PointLabelObject } from "highcharts";

export const getShortMonthWithDay = (dates: number[]) => {
    return dates.map(date => formatDateWithTemplate(date))
}

type ItemKey = 'plannedIdlesByType' | 'unplannedIdlesByType';

export const getChartSummary = (elements: IdleDetailingItem[], key: ItemKey) => {
    return elements.length > 0
        ? elements
            .map(element => element[key]
                .map(factElement => factElement.fact))
            .map(item => [sum(item)])
        : []
}

export const labelFormatter = function (ctx: PointLabelObject, plannedSummary: number[][], unplannedSummary: number[][]) {
    if (isNumber(ctx.x)) {
        const x = Math.abs(Math.round(ctx.x))

        const total = plannedSummary[x][0] + unplannedSummary[x][0]

        return { summary: formatTime(total, dataLabelsFormatter), displayInPlanned: plannedSummary[x][0] > unplannedSummary[x][0] }
    }
}